import React from 'react';
import { Trans } from 'react-i18next';

import { config } from '~/config';
import { useUserUpload } from '~/views/alfred/research/use-user-upload/useUserUpload';

import styles from './UploadDisclaimer.module.scss';

export const UploadDisclaimer = () => {
  const files = useUserUpload(state => state.files);

  return (
    <div className={styles.uploadDisclaimer}>
      {!!files.length && (
        <Trans
          i18nKey="chat:uploadDisclaimer"
          components={[
            <a
              className={styles.styledAnchor}
              key="key-0"
              href={config.urls.disclaimerFileUpload}
              target="_blank"
              rel="noreferrer noopener"
            />,
          ]}
        />
      )}
    </div>
  );
};
